module.exports = __webpack_public_path__ + "OpenSans-Regular.cfabf0c2b781600308b8.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/customfonts/OpenSans-Regular.eot
// module id = ../../../../../src/assets/customfonts/OpenSans-Regular.eot
// module chunks = styles